module.exports = function _identity(x) { return x; };



//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_identity.js
// module id = ./node_modules/ramda/src/internal/_identity.js
// module chunks = 54 55 56